import { useEffect as c } from "react";
const l = ({ messageId: n = 1192723 }) => (c(() => {
  let a = 0;
  const t = setInterval(() => {
    a++;
    const e = document.querySelector(".privacy-preferences-trigger");
    e && (e.addEventListener("click", (o) => {
      var r;
      o.preventDefault(), (r = window._sp_) != null && r.usnat ? window._sp_.usnat.loadPrivacyManagerModal(n) : console.warn("Sourcepoint usnat not found.");
    }), clearInterval(t)), a > 1e3 && (clearInterval(t), console.warn("Privacy preference button not found."));
  }, 100);
  return () => {
    const e = document.querySelector(".privacy-preferences-trigger");
    e && e.removeEventListener("click", (o) => {
      var r;
      o.preventDefault(), (r = window._sp_) != null && r.usnat ? window._sp_.usnat.loadPrivacyManagerModal(n) : console.warn("Sourcepoint usnat not found.");
    }), clearInterval(t);
  };
}, [n]), null);
export {
  l as default
};
